import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });
    return res.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isArcadeCompetitionsApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getArcadeCompetitionsPayload = (res) => res?.data ?? null;

/** GET /admin/arcade/competitions */
export const listArcadeCompetitions = ({
  search,
  enabledOnly,
  limit = 50,
  offset = 0,
} = {}) => {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (enabledOnly) params.set('enabled_only', 'true');
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  return authFetch(`/admin/arcade/competitions?${params.toString()}`, { method: 'GET' });
};

/** GET /admin/arcade/competitions/:cid */
export const getArcadeCompetition = (cid) =>
  authFetch(`/admin/arcade/competitions/${cid}`, { method: 'GET' });

/** PATCH /admin/arcade/competitions/:cid */
export const patchArcadeCompetition = (cid, body) =>
  authFetch(`/admin/arcade/competitions/${cid}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
